import React from 'react';
import { IonPage, IonContent } from '@ionic/react';
import WebSidebar from './WebSidebar';
import WebHeader from './WebHeader';

interface WebLayoutProps {
  children: React.ReactNode;
  title: string;
}

export const WebLayout: React.FC<WebLayoutProps> = ({ children, title }) => {
  return (
    <IonPage style={{ maxWidth: 'none', width: '100vw' }}>
      <WebHeader title={title} />
      
      <IonContent 
        scrollY={false} 
        style={{ 
          '--padding-start': '0px', 
          '--padding-end': '0px', 
          '--padding-top': '0px', 
          '--padding-bottom': '0px',
          '--ion-grid-width': '100%',
          '--ion-grid-width-xs': '100%',
          '--ion-grid-width-sm': '100%',
          '--ion-grid-width-md': '100%',
          '--ion-grid-width-lg': '100%',
          '--ion-grid-width-xl': '100%',
          maxWidth: 'none',
          width: '100%'
        } as React.CSSProperties}
      >
        <div style={{ height: '100%', width: '100%', maxWidth: 'none', display: 'flex', flexDirection: 'row' }}>
          {/* Left Sidebar Navigation */}
          <div style={{ width: '16.666%', height: '100%', overflowY: 'auto', padding: 0, flexShrink: 0 }}>
            <WebSidebar />
          </div>
          
          {/* Main Content Area */}
          <div style={{ flex: 1, height: '100%', padding: 0, minWidth: 0 }}>
            {children}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};
